// Data/Tables/Inventory/Adjustments/tables.js
const tables = [
    {
        name: "Date"
    },
    {
        name: "Batch"
    },
    {
        name: "Product"
    },
    {
        name: "Type"
    },
    {
        name: "Quantity"
    },
    {
        name: "Before"
    },
    {
        name: "After"
    },
    {
        name: "Reason"
    },
    {
        name: "Status"
    },
    {
        name: "Action"
    },
];

export default tables;